module.exports = __webpack_public_path__ + "img/sczp.e79a1423.png";